import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsWalkNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#sports_walk_normal_large_svg__clip0_138_69)" fill="">
        <path d="M12.99 38H8v2h4.99v-2zM20 38h-5.01v2H20v-2zm14 0h-5v2h5v-2zm-7 0h-5v2h5v-2z" />
        <path d="M46.55 27.45A4.931 4.931 0 0043.04 26h-4.8L23.4 18.1l-3.78-7.11h-2.11A3.523 3.523 0 0014 14.51v2.23l-1.64 2.98a2.462 2.462 0 01-4.34-.04l-.49-.92a3.289 3.289 0 00-2.92-1.77H2v14.59l-.67.67A4.54 4.54 0 004.54 40H6v-2H4.54a2.544 2.544 0 01-2.352-3.51c.128-.308.315-.586.552-.82l.67-.67H20v-2H4V18.99h.61a1.3 1.3 0 011.15.7l.49.92c.383.72.953 1.325 1.65 1.75a4.454 4.454 0 006.21-1.68L16 17.25v-2.74a1.517 1.517 0 011.51-1.52h.91l3.5 6.59 2.542 1.351-1.345 2.527 1.766.939 1.346-2.528 2.34 1.25-1.349 2.534 1.765.941 1.348-2.532 2.315 1.227-1.355 2.544 1.766.94 1.353-2.542L37.74 28h5.3A2.954 2.954 0 0146 30.96a3.929 3.929 0 01-1.15 2.78A14.457 14.457 0 0136 37.93v2a16.3 16.3 0 0010.26-4.78A5.895 5.895 0 0048 30.96a4.957 4.957 0 00-1.45-3.51z" />
      </g>
      <defs>
        <clipPath id="sports_walk_normal_large_svg__clip0_138_69">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgSportsWalkNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsWalkNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsWalkNormalLarge;
